<div class="gauge-track" [ngStyle]="{ height: trackHeight, 'background-color': trackColorHexa }">
    @for (marker of markers; track marker) {
        <div [class]="'marker ' + marker.markerType" [ngStyle]="{ left: getPositionPercentage(marker) + '%' }"></div>
        @if (marker.label) {
            <div
                [class]="'label ' + marker.markerType"
                [ngStyle]="{ left: getPositionPercentage(marker) + '%', top: marker.labelVerticalOffset + '%', color: trackColorHexa }"
            >
                {{ marker.label }}
            </div>
        }
    }
</div>
